import { ShortCodeEnums } from '@nhl/nhl-breakaway-ui';

import { CountryCode } from '~/core/enums';
import { Broadcast, WebStream } from '~/core/types';
import toolkitApi from '~/redux/toolkitApi';

import * as webStreamUtils from './utils';

const MAX_STREAM_URL = 'https://www.max.com/sports/nhl';
const TVA_STREAM_URL = 'https://www.tvasportsdirect.ca';

type WebStreamArgs = {
    countryCode: CountryCode;
    baseUrl?: string;
    broadcasts: Array<Broadcast>;
    language: ShortCodeEnums.Language;
};

export default toolkitApi.injectEndpoints({
    endpoints: (build) => ({
        getWebStreamURL: build.query<string | undefined, WebStreamArgs>({
            query: ({ baseUrl = window?.__SITE_SETTINGS__?.configBaseURL }) => ({
                url: `${baseUrl}/streaming/web_stream_config.json`,
            }),
            transformResponse: (webStreams: WebStream, meta, args) => {
                if (webStreams.countryMap && !webStreamUtils.isNoStreamBroadcast(args.countryCode, args.broadcasts)) {
                    if (
                        args.countryCode === CountryCode.UnitedStates &&
                        webStreamUtils.isMaxBroadcast(args.broadcasts)
                    ) {
                        return MAX_STREAM_URL;
                    } else if (
                        args.countryCode === CountryCode.Canada &&
                        args.language === ShortCodeEnums.Language.French &&
                        webStreamUtils.isTVABroadcast(args.broadcasts)
                    ) {
                        return TVA_STREAM_URL;
                    }

                    const countryId = webStreams.countryMap[args.countryCode.toUpperCase()];
                    return webStreams.webStreamingURLs.find((stream) => stream.id === countryId)?.url;
                }

                return undefined;
            },
        }),
    }),
});
